import React from 'react'
import { ArrowDown } from 'kunstmuseum-icons'
import { gsap, Power2, ScrollTrigger, ScrollToPlugin } from 'gsap/all'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

class ExhibitionHead extends React.Component {
    constructor(props) {
        super(props)

        this.animateEnterSite = this.animateEnterSite.bind(this)
        this.domRef = React.createRef()
    }

    componentDidMount() {
        // Set up parallax background animation.
        this.domRef.current.style.backgroundPosition = "50% 0px"

        gsap.to(this.domRef.current, {
            backgroundPosition: `50% ${this.domRef.current.offsetHeight / 2}px`,
            ease: "none",
            scrollTrigger: {
                trigger: this.domRef.current,
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        })
    }
    
    animateEnterSite() {
        gsap.to(window, {
            scrollTo: {
                y: this.domRef.current.offsetHeight
            },
            duration: 0.5,
            ease: Power2.easeOut
        })
    }

    render() {
        const {
            backgroundImageRef,
            backgroundColor,
            lightText,
            title,
            subtitle,
            startDate,
            endDate
        } = this.props

        const style = {
            backgroundImage: 'url(' + backgroundImageRef + ')',
            backgroundColor: backgroundColor,
            color: lightText && '#FFF',
        }

        return (
            <section className="exhibition-head" style={style} ref={this.domRef}>
                <div>
                    <h2 className="exhibition-title">{title}</h2>
                    <h3 className="exhibition-subtitle h2">{subtitle}</h3>
                </div>
                <div>
                    <div className="exhibition-date-range h2">
                        {startDate}&#8202;—<br />&#8202;{endDate}
                    </div>
                </div>
                <button className="button-enter-site" onClick={this.animateEnterSite} title="Seite betreten">
                    <ArrowDown />
                </button>
            </section>
        )
    }
}

export default ExhibitionHead